import React = require('react');
import { Col, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../../../../components/FieldFormControl';
import { isRequired } from '../../../../../../../../../util/validators';
import { useState } from 'react';

interface IMTACardConsentProps {
  permissions: boolean
}

export const MTACardConsent = ({ permissions }: IMTACardConsentProps) => {
  const [showSaveCard, setShowSaveCard] = useState(false);

  const handleOnLinkClick = () => () => {
    setShowSaveCard(!showSaveCard)
  }

  return (
    <div>
      <p className={'normal'} style={{ fontSize: '15px' }}>
        Payments: We will securely save your payment card so payments on your policy can be handled quicker and
        easier– this
        includes any future changes including policy renewal. You can cancel this by contacting us at any time or
        clicking <a onClick={handleOnLinkClick()} style={{ cursor: 'pointer' }}>here</a>.
      </p>
      {showSaveCard && (
        <>
          <p style={{ fontSize: '15px' }}>We store card details securely and they are
            encrypted against your policy allowing us to take any future payments quickly and easily</p>
          <Row className="billing">
            <Col sm={12} className={'send-documents-box'} style={{ paddingBottom: '5px' }}>
              <div className="section">
                <Row className="billing">
                  <Col xs={6} className={'radio-group margin-top'}>
                    <div className={'option'}>
                      <div className="radio-button">
                        <Field
                          name="permissions"
                          type="radio"
                          value={true}
                          complexValue={true}
                          component={FieldFormControl}
                          validate={[isRequired]}
                        >
                          <div/>
                        </Field>
                      </div>
                      <div className="radio-text">
                        {'Save the card details'}
                      </div>
                    </div>
                  </Col>
                  <Col xs={6} className={'radio-group margin-top'}>
                    <div className={'option'}>
                      <div className="radio-button">
                        <Field
                          name="permissions"
                          type="radio"
                          value={false}
                          complexValue={true}
                          component={FieldFormControl}
                          validate={[isRequired]}
                        >
                          <div/>
                        </Field>
                      </div>
                      <div className="radio-text">
                        {'Do not save the card details'}
                      </div>
                    </div>
                  </Col>
                  {!permissions && (
                    <>
                      <div style={{ padding: '0 20px 0 20px' }}>You will need to give us your payment details every
                        time you make a change or when you’d like to renew with us
                      </div>
                    </>
                  )}
                </Row>
              </div>
            </Col>
          </Row>
        </>
      )}
    </div>
  )
}
